import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/HeroBanner/HeroBanner.js
const HeroBanner = createSectionForm({
  icon: "image-2-line",
  title: "Hero Banner",
  fields: [
    {
      name: "title",
      label: "Title",
      type: "textarea",
      rows: 2,
      help: "Basic HTML allowed, e.g. <span>Repair.</span> Replace. Revive.",
    },
    { name: "description", label: "Description", type: "richtext" },
    {
      name: "layers",
      label: "Background Images (left & right layers)",
      type: "list",
      itemLabel: "Layer",
      fields: [
        { name: "image", label: "Image", type: "media", max: 1 },
        { 
          name: "position", 
          label: "Position", 
          type: "select", 
          options: [{label: "Left", value: "left"}, {label: "Right", value: "right"}],
          defaultValue: "left"
        }
      ]
    },
    {
      name: "show_vehicle_selector",
      label: "Show Vehicle Selector",
      type: "switch",
      defaultValue: true,
    },
  ],
});

export default HeroBanner;
